import createReducer from 'redux/lib/reducerConfig';

const ActionTypes = {
  SET_ADD_SURVEY_SORTING: 'MARKET_PRICE/SET_ADD_SURVEY_SORTING',
  RESET_ADD_SURVEY_SORTING: 'MARKET_PRICE/RESET_ADD_SURVEY_SORTING',
};

export const setAddSurveySorting = (sorting) => ({
  type: ActionTypes.SET_ADD_SURVEY_SORTING,
  payload: sorting,
});

export const resetAddSurveySorting = () => ({
  type: ActionTypes.RESET_ADD_SURVEY_SORTING,
});

export const sortingInitialState = { jobTitle: 'ASC' };

export const addSurveySortingReducer = createReducer(
  sortingInitialState,
  {
    [ActionTypes.SET_ADD_SURVEY_SORTING]: (state, { payload }) => {
      return payload;
    },
  },{
    [ActionTypes.RESET_ADD_SURVEY_SORTING]: () => {
      return sortingInitialState;
    },
  },
);
